import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { useActionPermission } from "@/modules/auth/presentation/model/useActionPermission";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { useNavigate } from "@tanstack/react-router";
import { useZonesQuery } from "../api/queries";
import { useZonesTour, ZonesTour } from "../tour";
import { ZonesTable } from "../ui/ZonesTable";
import { ZonesToolbar } from "../ui/ZonesToolbar";

export function ZonesPage() {
  const nav = useNavigate({ from: "/app/shipping/zones" });
  const list = useZonesQuery();
  const zones = list.data ?? [];
  const canManage = useActionPermission(["shipping:create"]);
  const { run, handleJoyrideCallback, startTour } = useZonesTour();

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "ໂຊນ" },
          ]}
        />
      </Header>
      <Main>
        <ZonesToolbar
          canManage={!!canManage}
          onCreate={() => nav({ to: "/app/shipping/zones/new" })}
          onStartTour={startTour}
        />
        <div className="flex flex-col rounded-xl border bg-card pt-2">
          <ZonesTable
            canManage={!!canManage}
            data={zones}
            isLoading={list.isLoading}
            onEdit={(row) =>
              nav({
                to: "/app/shipping/zones/$id/edit",
                params: { id: row.id },
              })
            }
          />
        </div>
        <ZonesTour run={run} onCallback={handleJoyrideCallback} />
      </Main>
    </>
  );
}
